import { Loader2 } from 'lucide-react';

interface ButtonLoaderProps {
  size?: number;
  className?: string;
}

export const ButtonLoader = ({
  size = 20,
  className = '',
}: ButtonLoaderProps) => {
  return <Loader2 className={`animate-spin ${className}`} size={size} />;
};
